module.exports = __webpack_public_path__ + "media/details/workshop@1x-70852b05.png";